import { PageHeader } from '@frontendmentorio/design-system-v2';

import Layout from 'features/shared/Layout';
import ContactPage from 'features/pages/Contact';

export default function Contact() {
  return (
    <Layout
      description="Get in touch with the Frontend Mentor team. We'll be happy to answer any questions you've got!"
      image="https://res.cloudinary.com/dz209s6jk/image/upload/v1585172856/Meta/meta-homepage.png"
      title="Frontend Mentor | Contact"
      url="https://www.frontendmentor.io/contact"
    >
      <PageHeader heading="Contact" />
      <ContactPage />
    </Layout>
  );
}

export async function getStaticProps() {
  return { props: {} };
}
